import { ItemView, locale } from '@glu/core';

import template from '../text.hbs';

export default ItemView.extend({
  template,

  templateHelpers() {
    return {
      text: this.options.text || locale.get('thereIsNoTableCaption')
    };
  }
});
